import React, { useState } from 'react';
import './Contact.css';

const FORM_ENDPOINT =
	'https://fqm3jismek.execute-api.us-east-1.amazonaws.com/contact';

const services = [
	'Azure DevOps Migration',
	'CI/CD Modernization',
	'Infrastructure as Code',
	'DevSecOps & Shift-Left Security',
	'Something else',
];

export default function Contact() {
	const [form, setForm] = useState({
		name: '',
		email: '',
		company: '',
		service: '',
		message: '',
	});
	const [status, setStatus] = useState('idle'); // idle | sending | success | error

	const handleChange = (e) => {
		setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setStatus('sending');
		try {
			const res = await fetch(FORM_ENDPOINT, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(form),
			});
			if (res.ok) {
				setStatus('success');
				setForm({ name: '', email: '', company: '', service: '', message: '' });
			} else {
				setStatus('error');
			}
		} catch {
			setStatus('error');
		}
	};

	return (
		<section className='contact' id='contact'>
			<div className='contact__inner'>
				<div className='contact__left'>
					<div className='section-eyebrow' style={{ color: '#3a7fc1' }}>
						GET IN TOUCH
					</div>
					<h2 className='section-heading'>
						Let's talk about your infrastructure.
					</h2>
					<p className='contact__lead'>
						No pressure, no pitch deck. Just a conversation about where you are
						and where you want to go.
					</p>
					<div className='contact__details'>
						<div className='contact__detail'>
							<span
								className='contact__dot'
								style={{ background: '#3aafa9' }}
							/>
							hello@apiaryconsultingllc.com
						</div>
						<div className='contact__detail'>
							<span
								className='contact__dot'
								style={{ background: '#3a7fc1' }}
							/>
							Portland, OR · Tulsa, OK · Remote
						</div>
						<div className='contact__detail'>
							<span
								className='contact__dot'
								style={{ background: '#6db33f' }}
							/>
							Response within 1 business day
						</div>
					</div>
				</div>

				<div className='contact__form-wrap'>
					{status === 'success' ? (
						<div className='contact__success'>
							<div className='contact__success-icon'>✓</div>
							<h3>Message sent!</h3>
							<p>We'll be in touch within one business day.</p>
						</div>
					) : (
						<form className='contact__form' onSubmit={handleSubmit} noValidate>
							<div className='fg'>
								<label htmlFor='name'>NAME</label>
								<input
									id='name'
									name='name'
									type='text'
									placeholder='Your name'
									value={form.name}
									onChange={handleChange}
									required
								/>
							</div>
							<div className='fg'>
								<label htmlFor='email'>WORK EMAIL</label>
								<input
									id='email'
									name='email'
									type='email'
									placeholder='you@company.com'
									value={form.email}
									onChange={handleChange}
									required
								/>
							</div>
							<div className='fg'>
								<label htmlFor='company'>COMPANY</label>
								<input
									id='company'
									name='company'
									type='text'
									placeholder='Company name'
									value={form.company}
									onChange={handleChange}
								/>
							</div>
							<div className='fg'>
								<label htmlFor='service'>WHAT ARE YOU WORKING ON?</label>
								<select
									id='service'
									name='service'
									value={form.service}
									onChange={handleChange}
									required
								>
									<option value='' disabled>
										Select a service...
									</option>
									{services.map((s) => (
										<option key={s} value={s}>
											{s}
										</option>
									))}
								</select>
							</div>
							<div className='fg'>
								<label htmlFor='message'>TELL US MORE</label>
								<textarea
									id='message'
									name='message'
									placeholder='Brief description of your situation...'
									value={form.message}
									onChange={handleChange}
									rows={4}
								/>
							</div>
							{status === 'error' && (
								<p className='contact__error'>
									Something went wrong — please email us directly.
								</p>
							)}
							<button
								type='submit'
								className='contact__submit'
								disabled={status === 'sending'}
							>
								{status === 'sending' ? 'Sending...' : 'Send message →'}
							</button>
						</form>
					)}
				</div>
			</div>
		</section>
	);
}
